import React from 'react';
import AllPostsSection from '../../../sections/AdminDashboard/PostManagement/AllPosts';

const AllPosts = () => {
  return <AllPostsSection />;
};

export default AllPosts;

